import * as actionTypes from "../Actions/PaymentsActionTypes";
import LogService from "../../CommonSdk/LogService";

const LOG_TAG = "REDUCER:PAYMENT";

const initialState = {
    data: [],
    getPaymentMethodProgress: false,//billingView
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_PAYMENT_METHODS_PROGRESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get payment methods in progress");
            return {
                ...state,
                getPaymentMethodProgress: true
            };

        case actionTypes.GET_PAYMENT_METHODS_RECEIVED:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get payment methods received");
            return {
                ...state,
                data: action.payload.payments,
                getPaymentMethodProgress: false,
            };

        case actionTypes.GET_PAYMENT_METHODS_ERROR:
            LogService.warn(LOG_TAG, "reduce", "" + action.type + " - Get payment methods failed");
            return {
                ...state,
                getPaymentMethodProgress: false,
            };

        case actionTypes.CLEAR_PAYMENT_METHODS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Clear payment methods");
            return {
                ...initialState,
            };

        default:
            return state;    
    }
}